import { render, staticRenderFns } from "./tableMagangSDM.vue?vue&type=template&id=54d021e3&scoped=true"
import script from "./tableMagangSDM.vue?vue&type=script&lang=js"
export * from "./tableMagangSDM.vue?vue&type=script&lang=js"
import style0 from "./tableMagangSDM.vue?vue&type=style&index=0&id=54d021e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d021e3",
  null
  
)

export default component.exports